import { render } from "./AIpage.vue?vue&type=template&id=0fca6358&scoped=true"
import script from "./AIpage.vue?vue&type=script&lang=js"
export * from "./AIpage.vue?vue&type=script&lang=js"

import "./AIpage.vue?vue&type=style&index=0&id=0fca6358&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fca6358"]])

export default __exports__